import { MegaMenuItem } from '@design-system/components/m-mega-menu';
import { NavbarConstants } from '@portal/app/shared/types/navigation';
import { MenuItem } from 'primeng/api';

export type NavbarMetaEntry = {
  match: RegExp;
  id?: string;
  iconName: string;
  description: string;
};

export const SETTINGS_META: NavbarMetaEntry[] = [
  {
    match: /\/admin(\/|$)/,
    iconName: 'build',
    description: 'Customize your integrations, API access, and more.'
  },
  {
    match: /\/campaign-mapping/,
    iconName: 'automation',
    description: 'See AI-recommended tactic mapping or create your own.'
  },
  {
    match: /\/export-report/,
    iconName: 'file_export',
    description: `Download all of your brand's data, or choose specific parameters.`
  },
  {
    match: /\/onboarding/,
    id: NavbarConstants.onboardingId,
    iconName: 'explore',
    description: 'View customer acquisition insights and other trends.'
  },
  {
    match: /\/settings-manager/,
    iconName: 'app_registration',
    description: 'View customer acquisition insights and other trends.'
  },
  {
    match: /\/ddi-reporting/,
    iconName: 'app_registration',
    description: 'View customer acquisition insights and other trends.'
  },
  {
    match: /\/control-tower/,
    iconName: 'display_settings',
    description:
      'View all your data in one place and download it for your needs.'
  }
];

// TODO(navbar): replace dummy icons + copy with finalized content for each dashboard.
export const MORE_META: NavbarMetaEntry[] = [
  {
    match: /\/mim-page/,
    iconName: 'graph_5',
    description: 'Check your model performance and adjust input parameters.'
  },
  {
    match: /\/customer-reporting/,
    iconName: 'clinical_notes',
    description: 'Gain insights into your customers via LTV and CAC data.'
  },
  {
    match: /segment/i,
    iconName: 'donut_small',
    description: 'Detail direct mail insights.'
  },
  {
    match: /catalog/i,
    iconName: 'book_2',
    description: 'Measure the effectiveness of direct mail campaigns.'
  },
  {
    match: /crm/i,
    iconName: 'id_card',
    description: 'User-level testing for known audiences.'
  },
  {
    match: /\/geo-doe/,
    iconName: 'experiment',
    description: 'Run experiments to test regional content strategies.'
  },
  {
    match: /\/portfolio\//,
    iconName: 'analytics',
    description: 'Analyze portfolio performance.'
  },
  {
    match: /facebook|\/fb-/,
    iconName: 'campaign',
    description: 'Facebook insights and analysis.'
  },
  {
    match: /geo/,
    iconName: 'experiment',
    description: 'Run experiments to test regional content strategies.'
  },
  {
    match: /shopify/,
    iconName: 'storefront',
    description: 'Shopify dashboard insights.'
  },
  {
    match: /retargeting/,
    iconName: 'replay',
    description: 'Retargeting analysis.'
  }
];

export const AVATAR_META: Record<
  string,
  { iconName: string; label: string; description: string }
> = {
  [NavbarConstants.userAccountId]: {
    iconName: 'account_circle',
    label: 'Profile',
    description: 'Manage your personal data and security settings.'
  },
  logout: {
    iconName: 'logout',
    label: 'Log Out',
    description: 'End this session and return to the login screen.'
  }
};

export const supportBaseItems: MegaMenuItem[] = [
  {
    id: 'help-center',
    iconName: 'help_center',
    label: 'Help Center',
    description: 'Detailed documentation to answer product questions.',
    command: () => {
      window.open('https://support.measured.com/', '_blank');
    }
  },
  {
    id: 'customer-support',
    iconName: 'support_agent',
    label: 'Customer Support',
    description: 'Our experts can help you if you run into any problems.',
    command: () => {
      window.open(
        'https://measured.atlassian.net/servicedesk/customer/portal/2',
        '_blank'
      );
    }
  }
];

export const reportIssueItem = (openFeedback: () => void): MegaMenuItem => ({
  id: 'report-issue',
  iconName: 'pest_control',
  label: 'Report Issue',
  description: 'Found a bug? Let us know by sending a quick report.',
  command: openFeedback
});

const TABLEAU_EXPORT_TYPES = [
  { label: 'PDF', type: 'pdf', styleClass: 'tableau-export-item pdf' },
  { label: 'Excel', type: 'excel', styleClass: 'tableau-export-item excel' },
  { label: 'CSV', type: 'csv', styleClass: 'tableau-export-item csv' },
  { label: 'Image', type: 'image', styleClass: 'tableau-export-item image' },
  {
    label: 'Powerpoint',
    type: 'powerpoint',
    styleClass: 'tableau-export-item powerpoint'
  }
];

export const tableauExportItems = (
  onExport: (type: string) => void
): MenuItem[] =>
  TABLEAU_EXPORT_TYPES.map(({ label, type, styleClass }) => ({
    label,
    icon: 'pi pi-fw pi-file',
    styleClass,
    command: () => onExport(type)
  }));
